var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"paw",attrs:{"src":_vm.pawNewSrc,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }